module.exports = __webpack_public_path__ + "img/scenery-15.a0f0d58c.png";